<ng-container *transloco="let t">
    <div ngbDropdown class="dropdown dropdown--remove-arrow" container="body">
        <span class="menu-icon actions-button align-items-center" id="competitorActionsDropdown"
        ngbDropdownToggle>
        <i class="fas fa-ellipsis-v"></i>
        </span>
      <ul aria-labelledby="competitorActionsDropdown" ngbDropdownMenu>
        @if (((rowDropdownActions?.length ?? 0) > 0) && competitor && isNumber(index)) {
          @for (action of rowDropdownActions; track $index) {
            <li ngbDropdownItem (click)="handleDropdownAction(action, competitor, index!)">
              {{ t("competitor.table.dropdown.action." + action) }}
            </li>
          }
        }
      </ul>
    </div>
</ng-container>
